export default {"src":"/_next/static/media/close-matchday.cbc552bf.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};